var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2832_7819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 10.6663V12.533C10.6668 13.2797 10.6668 13.6531 10.5215 13.9383C10.3937 14.1892 10.1897 14.3932 9.93882 14.521C9.6536 14.6663 9.28023 14.6663 8.5335 14.6663H3.46683C2.72009 14.6663 2.34672 14.6663 2.06151 14.521C1.81063 14.3932 1.60665 14.1892 1.47882 13.9383C1.3335 13.6531 1.3335 13.2797 1.3335 12.533V7.46634C1.3335 6.7196 1.3335 6.34624 1.47882 6.06102C1.60665 5.81014 1.81063 5.60616 2.06151 5.47833C2.34672 5.33301 2.72009 5.33301 3.46683 5.33301H5.3335M7.46683 10.6663H12.5335C13.2802 10.6663 13.6536 10.6663 13.9388 10.521C14.1897 10.3932 14.3937 10.1892 14.5215 9.93833C14.6668 9.65311 14.6668 9.27974 14.6668 8.53301V3.46634C14.6668 2.7196 14.6668 2.34624 14.5215 2.06102C14.3937 1.81014 14.1897 1.60616 13.9388 1.47833C13.6536 1.33301 13.2802 1.33301 12.5335 1.33301H7.46683C6.72009 1.33301 6.34672 1.33301 6.06151 1.47833C5.81063 1.60616 5.60665 1.81014 5.47882 2.06102C5.3335 2.34624 5.3335 2.7196 5.3335 3.46634V8.53301C5.3335 9.27974 5.3335 9.65311 5.47882 9.93833C5.60665 10.1892 5.81063 10.3932 6.06151 10.521C6.34672 10.6663 6.72009 10.6663 7.46683 10.6663Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2832_7819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.5e1589dd67fd9da50f7725cc6e553241.svg";
export { ForwardRef as ReactComponent };